import script from "./EditStudentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditStudentModal.vue?vue&type=script&setup=true&lang=js"

import "./EditStudentModal.vue?vue&type=style&index=0&id=8e9a8268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e9a8268"]])

export default __exports__